import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export function FloatingProduct() {
  return <div className="sticky top-8 bg-white rounded-2xl border border-gray-200 shadow-xl p-5 font-sans hidden lg:block w-80" data-id="element-22">
      <div className="absolute -top-3 -right-3 bg-brand-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md uppercase tracking-wide" data-id="element-23">
        En Stock
      </div>

      <img src="https://cdn.magicpatterns.com/uploads/wDA81QL7oUdyT7dKdNT7zL/hf_20260313_142719_2d88c4a5-9345-4046-8603-a8f9b1d4c618.jpg" alt="Lissea Device" className="w-full h-auto rounded-xl mb-4 object-cover" data-id="element-24" />

      <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-25">
        Lissea™ - Appareil de Soin Corporel
      </h3>

      <div className="flex items-center gap-1 mb-3" data-id="element-26">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-brand-500 text-brand-500" data-id="element-27" />)}
        <span className="text-sm text-gray-600 ml-1" data-id="element-28">(4.8/5)</span>
      </div>

      <div className="mb-5" data-id="element-29">
        <span className="text-3xl font-bold text-gray-900" data-id="element-30">79,95 €</span>
        <span className="text-sm text-gray-500 line-through ml-2" data-id="element-31">
          119,95 €
        </span>
      </div>

      <ul className="space-y-2 mb-6 text-sm text-gray-600" data-id="element-32">
        <li className="flex items-center gap-2" data-id="element-33">
          <div className="w-1.5 h-1.5 rounded-full bg-brand-500" data-id="element-34"></div>
          Livraison gratuite
        </li>
        <li className="flex items-center gap-2" data-id="element-35">
          <div className="w-1.5 h-1.5 rounded-full bg-brand-500" data-id="element-36"></div>
          Garantie 60 jours
        </li>
        <li className="flex items-center gap-2" data-id="element-37">
          <div className="w-1.5 h-1.5 rounded-full bg-brand-500" data-id="element-38"></div>
          Paiement sécurisé
        </li>
      </ul>

      <CTAButton fullWidth className="py-3 text-base" data-id="element-39">
        Vérifier la disponibilité
      </CTAButton>
    </div>;
}